import { ButtonListControl } from '../../../engineClient/components/formControls/standard';
import { HpInputControlProps } from '../../../engineClient/types';
import { HpClaimsQuestionSetPageProps } from '../../questionSetForm/questionSetPageTypes';
import { resolveTokensInQuestionText } from './customControlUtilities';

interface ButtonListWithDynamicQuestionTextCustomControlProps extends HpInputControlProps {
  pageProps: HpClaimsQuestionSetPageProps;
}

export function ButtonListWithDynamicQuestionTextCustomControl(
  props: ButtonListWithDynamicQuestionTextCustomControlProps
): JSX.Element {
  const { answers, questionText, pageProps } = props;
  const { questions, productId } = pageProps;

  const questionTextWithResolvedTokens = resolveTokensInQuestionText({
    questionText,
    answers,
    questions,
    productId
  });

  return <ButtonListControl {...props} questionText={questionTextWithResolvedTokens} />;
}
